import * as Scrivito from 'scrivito';

// The browser SDK talks to api.scrivito.com directly: published content is
// world-readable (it needs no credentials) and the editor authenticates itself
// with its own JustRelate session. Routing this through a server-side proxy is
// what previously broke editor login and blocked saving, because an API key can
// only ever see the published workspace.
Scrivito.configure({
  tenant: import.meta.env.VITE_SCRIVITO_TENANT,
});
